import {
  init as initSDK,
  postEvent,
  retrieveLaunchParams,
  setMiniAppHeaderColor
} from '@telegram-apps/sdk-react';
import { type FC, PropsWithChildren, useCallback, useEffect } from 'react';
import { Slide, ToastContainer } from 'react-toastify';
import { matchPath, useLocation } from 'react-router-dom';

import usePolling from '@/hooks/usePolling.ts';
import ProfileController from '@/api/profile/profile.ts';
import UIConfig from '@/UIConfig.ts';
import { useProfileStore } from '@/store/useProfileStore.ts';
import { helpers } from '@/helpers.ts';
import { routes } from '@/navigation/routes.tsx';
import { JoyrideProvider } from '@/providers/JoyrideProvider/JoyrideProvider.tsx';

export const App: FC<PropsWithChildren> = ({ children }) => {
  const { aboutMe } = useProfileStore();
  const location = useLocation();

  const { tgWebAppVersion, tgWebAppPlatform } = retrieveLaunchParams();

  usePolling(
    aboutMe?.profile.state,
    useCallback(() => {
      return ProfileController.markOnline({
        device_id: helpers.getDeviceId(),
        tg_bot_version: tgWebAppVersion,
        tg_platform: tgWebAppPlatform
      });
    }, [])
  );

  initSDK();

  postEvent('web_app_expand');
  postEvent('web_app_setup_swipe_behavior', { allow_vertical_swipe: false });
  postEvent('web_app_setup_closing_behavior', { need_confirmation: true });
  postEvent('web_app_request_fullscreen'); // TODO requires container changes

  document.body.style.backgroundColor = UIConfig.Colors.BackgroundWhite;

  useEffect(() => {
    const chatMatch = matchPath(
      {
        path: routes.chat
      },
      location.pathname
    );

    if (
      location.pathname === routes.search ||
      location.pathname === routes.messenger
    ) {
      setMiniAppHeaderColor('#1D1D1D');
    } else if (location.pathname === routes.profile) {
      setMiniAppHeaderColor('#ffffff');
    } else if (chatMatch) {
      setMiniAppHeaderColor('#FFFFFF');
    } else {
      setMiniAppHeaderColor('#f5f5f5');
    }
  }, [location.pathname]);

  return (
    <JoyrideProvider>
      <ToastContainer
        position="top-center"
        draggable={false}
        closeButton={false}
        closeOnClick={false}
        autoClose={1500}
        hideProgressBar
        limit={1}
        transition={Slide}
      />
      {children}
    </JoyrideProvider>
  );
};